import React from 'react'
import PropTypes from 'prop-types'

import Loader from 'Pods/Shared/Loader'

import DetailsStep from './DetailsStep'

class EditDetailsStep extends React.Component {
  constructor() {
    super()

    this.state = {
      collectionData: {},
      collectionImages: [],
      collectionEmbeds: [],
      fetchingData: true,
    }

    this.onFetchSuccess = this.onFetchSuccess.bind(this)
  }

  componentDidMount() {
    axios.get(`/api/internal/collections/${this.props.editableCollectionId}`)
      .then((response) => this.onFetchSuccess(response))
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    const images = []
    const embeds = []

    response.data.data.relationships.itemImages.data.map((itemImage) => {
      images.push(response.data.included.find((image) => image.id === itemImage.id))
    })

    response.data.data.relationships.itemEmbeds.data.map((itemEmbed) => {
      embeds.push(response.data.included.find((embed) => embed.id === itemEmbed.id))
    })

    this.setState({
      collectionData: response.data.data,
      collectionImages: images,
      collectionEmbeds: embeds,
      fetchingData: false,
    })
  }

  render() {
    return (
      this.state.fetchingData ? (
        <div className="overlay-modal--loading-content">
          <Loader isFullHeight />
        </div>
      ) : (
        <DetailsStep
          onModalClose={this.props.onModalClose}
          data={this.state.collectionData.attributes}
          images={this.state.collectionImages}
          suggestedPrice={this.state.collectionData.attributes.modelsPrice}
          embeds={this.state.collectionEmbeds}
          isEditing
        />
      )
    )
  }
}

EditDetailsStep.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  editableCollectionId: PropTypes.string.isRequired,
}

export default EditDetailsStep
